import MilestonesSerializer from './base';

export default class MilestoneSet extends MilestonesSerializer {
  payloadKeyFromModelName(modelName) {
    return super
      .payloadKeyFromModelName(modelName)
      .replace('milestoneSet', 'milestoneset');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      key.replace('milestoneset', 'milestoneSet'),
    );
  }

  normalizeArrayResponse(store, primaryModelClass, payload) {
    if (!Array.isArray(payload.milestoneSetTemplates)) {
      // If there are no Milestone Set Templates, Go may omit the empty key.
      payload.milestoneSetTemplates = [];
    }
    return super.normalizeArrayResponse(...arguments);
  }
}
